import React from 'react';
import cn from 'classnames';
import { CheckIcon } from '../../Icons';

export interface TagProps {
  level?: '1' | '2' | '3' | 'sent';
  children: React.ReactNode;
  className?: string;
}

export const Tag: React.FC<TagProps> = ({ level = '3', children, className }) => {
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center',
        'text-ds-text-s font-semibold',
        {
          'gap-2.5 py-1 px-2 rounded-lg': level !== 'sent',
          'gap-1 py-px px-1.5 rounded-md': level === 'sent',
        },
        'text-ds-text-1',
        {
          'bg-ds-bg-feedback-soft-error': level === '1',
          'bg-ds-bg-feedback-soft-info': level === '2',
          'bg-ds-bg-surface-5': level === '3',
          'bg-ds-bg-surface-soft-5': level === 'sent',
        },
        className,
      )}
    >
      {children}
      {level === 'sent' && (
        <CheckIcon variant="thin" className="shrink-0 size-3 aspect-square" aria-hidden />
      )}
    </span>
  );
};

export default Tag;
